import { render, staticRenderFns } from "./ListService.vue?vue&type=template&id=05bb9843"
import script from "./ListService.vue?vue&type=script&lang=js"
export * from "./ListService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports